export type PercentageErrorMessagesKey = 'inputError.percentage.base'
export const ERROR_PERCENTAGE_BASE: PercentageErrorMessagesKey = 'inputError.percentage.base'

export const isBetweenPositive0And100 = (value: string | number) => Number(value) >= 0 && Number(value) <= 100
